import { mockedDictionary as l } from "../../components/__mock/index.js";
const f = (e) => {
  const o = {};
  return !e || Object.keys(e).length === 0 ? (console.warn("Dictionary is empty or undefined. Using mocked dictionary."), f(l)) : (Object.keys(e).reduce((t, i) => {
    const u = e[i], s = i.split(".");
    return s.reduce((r, n, c) => (c === s.length - 1 ? r[n] = u : r[n] || (r[n] = {}), r[n]), t), t;
  }, o), o);
};
export {
  f as processDictionary
};
